export default "__VITE_ASSET__7508c06b__"